import { useMemo } from "react"
import { isEmail, isNumberString, isObject, isURL } from 'class-validator';
import { activeEmailRegex, activePhoneRegex, phoneRegex, numbersRegex, numberStringRegex, httpRegex, fullNameRegex, useEndOfNextDecember } from '@hilma/netina2all';
import moment from 'moment';

import { createRules } from '../functions';


export const useAssociationEditingRules = () => {

	const endOfNextDecember = useEndOfNextDecember();

	return useMemo(() => (
		createRules({
			image: { required: false },
			associationName: { required: true, greaterThan: 2, smallerThan: 50, name: i18n => i18n.am.name },
			email: { required: true, activeRegex: activeEmailRegex, classValidator: (value: string) => isEmail(value) },
			phone: { name: i18n => i18n.am.phone, regex: phoneRegex, activeRegex: activePhoneRegex, activeRegexErr: i18n => i18n.errText.numbersOnly, required: true, length: 10 },
			contact: { required: true, name: i18n => i18n.am.contactPerson, greaterThan: 2, smallerThan: 45, regex: fullNameRegex },
			signedContract: { required: false, accept: ['application/pdf'] },
			properManagement: { required: false, accept: ['application/pdf'] },
			section46: { required: false, accept: ['application/pdf'] },
			section46Expiry: { required: false, after: endOfNextDecember, classValidator: (date) => moment(date).isAfter(endOfNextDecember) },
			bankAccountHolder: { required: false, name: i18n => i18n.am.bankInfo.accountHolderRule, greaterThan: 2, smallerThan: 45 },
			bankName: { required: false, classValidator: (value: Object) => isObject(value) },
			bankBranchNumber: { required: false, classValidator: (value: string) => isNumberString(value), activeRegex: numberStringRegex, greaterThan: 2, smallerThan: 4, name: 'הסניף' },
			bankAccountNumber: { required: false, classValidator: (value: string) => isNumberString(value), activeRegex: numberStringRegex, name: 'מספר החשבון' },
			volunteerNumber: { required: false, classValidator: (value: string) => isNumberString(value), activeRegex: numbersRegex, regex: numbersRegex, name: 'כמות המתנדבים' },
			website: { name: i18n => i18n.am.web, required: true, classValidator: (value: string) => isURL(value), regex: httpRegex, activeRegex: httpRegex, activeRegexErr: i18n => i18n.errText.website },
			goalKits: { required: false, classValidator: (value: string) => isNumberString(value), activeRegex: numbersRegex },
		})
	), [endOfNextDecember]);

}